import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import routesMap from 'src/js/router/helpers/routes-map';
import user from 'src/js/modules/user';
import sites from 'src/js/modules/sites';
import migrateURL from 'src/js/router/helpers/migrate-url';
import { AI_OPTIONAL_TEMPLATE_SELECTION_STEP_FLAG } from '../../constants/common';
import useFeatureFlags from '../../modules/feature-flags/hooks/use-feature-flags';

const FallbackRedirect = ({
  isWhiteLabel,
  platformAccess,
  siteIdRecreate,
  siteIdToSwitchTemplate,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [featureFlags] = useFeatureFlags([AI_OPTIONAL_TEMPLATE_SELECTION_STEP_FLAG]);
  const {
    [AI_OPTIONAL_TEMPLATE_SELECTION_STEP_FLAG]: isOptionalTemplateSelectionStepEnabled,
  } = featureFlags;

  useEffect(() => {
    const url = `${location.pathname}${location.search || ''}`;
    const newURL = migrateURL(url);

    if (url !== newURL) {
      navigate(newURL, { replace: true });
    }
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, []);

  const b2cFullAccess =
    !isWhiteLabel &&
    platformAccess === user.platformAccess.ALL &&
    !siteIdRecreate &&
    !siteIdToSwitchTemplate;
  const isPlatformSelectorPageAvailable = b2cFullAccess && !isOptionalTemplateSelectionStepEnabled;

  const firstStepUrl = routesMap.siteCategory.url();
  const galleryPath = siteIdToSwitchTemplate ? routesMap.gallery.url() : firstStepUrl;

  const redirectPath = isPlatformSelectorPageAvailable
    ? routesMap.platformSelector.url()
    : galleryPath;

  return <Navigate to={redirectPath} replace />;
};

FallbackRedirect.defaultProps = {
  isWhiteLabel: false,
  platformAccess: null,
  siteIdRecreate: null,
  siteIdToSwitchTemplate: null,
};

FallbackRedirect.propTypes = {
  isWhiteLabel: PropTypes.bool,
  platformAccess: PropTypes.string,
  siteIdRecreate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  siteIdToSwitchTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

const mapStateToProps = (state) => {
  const { isWhiteLabel } = user.selectors.getUserData(state);
  const { platformAccess } = user.selectors.getUserPreferences(state) || {};
  const siteIdRecreate = sites.selectors.getSiteIdRecreate(state);
  const siteIdToSwitchTemplate = sites.selectors.getSiteIdToSwitchTemplate(state);

  return {
    isWhiteLabel,
    platformAccess,
    siteIdRecreate,
    siteIdToSwitchTemplate,
  };
};

export default connect(mapStateToProps, null)(FallbackRedirect);
